angular.module('statBannerClicks', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/stat-banner-clicks/stat-banner-clicks.module.js